import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './index.module.sass';
import { useTranslation } from 'react-i18next';
import superagent from 'superagent';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

//Dependencies
import Parser from 'html-react-parser';

import GetFichaTecnicaProducto from '../Queries/getFichaTecnicaProducto';

// Images
import Back from '../ProductImageZoom/back.svg';
import pdfIcon from '../../images/productos/pdfRed.svg';
import download from '../../images/productos/downloadVideo.svg';

function TabPanel(props) {
  const { idioma, children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const Product = (props) => {
  const { device, history } = props;
  const { screenSize } = device;
  let { id = '' } = useParams();
  const [loading, setLoading] = useState(false);
  const [productID, setProductID] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [ingredients, setIngredients] = useState('');
  const [application, setApplication] = useState('');

  const { i18n = {}, t } = useTranslation('products');
  const { language = '' } = i18n;

  const [existeRuta, setexisteRuta] = useState(false);
  const [existeRutaVideo, setexisteRutaVideo] = useState(false);

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    async function getDescriptions() {
      // alert('Hola entre aquí');
      setLoading(true);
      const response = await GetFichaTecnicaProducto(id);
      const tmpProduct = response.producto || [];

      const ingredientes = response.listaIngredientes;

      console.log(response);

      const {
        aplicacion1 = '',
        aplicacion2 = '',
        descripcion1 = '',
        descripcion2 = '',
        codigoProducto = '',
        nombreProducto1 = '',
        nombreProducto2 = '',
      } = tmpProduct;

      const ingredientesHTML = `
  <ul>
    ${ingredientes
      ?.map((item) => `<li><strong>${item.nombre1}</strong>: ${item.descripcion1}</li>`)
      .join('')}
  </ul>
`;

      const ingredientesHTMLIngles = `
  <ul>
    ${ingredientes
      ?.map((item) => `<li><strong>${item.nombre2}</strong>: ${item.descripcion2}</li>`)
      .join('')}
  </ul>
`;

      setProductID(codigoProducto);
      setName((language.includes('es') && nombreProducto1) || nombreProducto2);
      setDescription((language.includes('es') && descripcion1) || descripcion2);
      setIngredients((language.includes('es') && ingredientesHTML) || ingredientesHTMLIngles);
      setApplication((language.includes('es') && aplicacion1) || aplicacion2);
      setLoading(false);
    }
    getDescriptions();
  }, [id, language]);

  function setAltImg(event) {
    event.target.src =
      'https://webimages.terramarbrands.com.mx/shopping-cart/cart-products-gray/preload.jpg';
  }

  useEffect(() => {
    if (productID) {
      // Para verificar si existe el PDF de la ficha tecnica
      const url = language.includes('es')
        ? `https://api.terramarbrandsmx.com/webapiAdmincarritomx/api/general/ExisteRuta?ruta=https://webimages.terramarbrands.com.mx/webpage/productos/fichasTecnicas/${productID}.pdf`
        : `https://api.terramarbrandsmx.com/webapiAdmincarritomx/api/general/ExisteRuta?ruta=https://webimages.terramarbrands.com.mx/webpage/productos/fichasTecnicasIngles/${productID}.pdf`;
      superagent
        .get(url)
        .set('Content-Type', 'application/json')
        .then((res) => {
          setLoading(true);
          setexisteRuta(res.body.data);
          setLoading(false);
        });
    }
  }, [productID, language]);

  useEffect(() => {
    if (productID) {
      // Para verificar si existe el video de la ficha tecnica
      const url = `https://api.terramarbrandsmx.com/webapiAdmincarritomx/api/general/ExisteRuta?ruta=https://webimages.terramarbrands.com.mx/webpage/productos/videos/${productID}.mp4`;
      superagent
        .get(url)
        .set('Content-Type', 'application/json')
        .then((res) => {
          setLoading(true);
          setexisteRutaVideo(res.body.data);
          setLoading(false);
        });
    }
  }, [productID]);

  return (
    <>
      <div className={styles.back} onClick={() => history.push('/products')}>
        <img src={Back} alt='Back' className={styles.iconBack} /> Regresar
      </div>

      <div id={styles.Product} className={styles[screenSize]}>
        {(loading && (
          <>
            <div className={styles.imageContainer}>&nbsp;</div>
            <div className={styles.dataContainer}>
              <Box sx={{ width: '100%' }}>
                <div className={styles.productName}></div>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  textColor='secondary'
                  indicatorColor='primary'
                  aria-label='secondary tabs example'>
                  <Tab label={t('description')} className={styles.tabColor} />
                  <Tab label={t('ingredients')} className={styles.tabColor} />
                  <Tab label={t('aplication')} className={styles.tabColor} />
                  <Tab label={t('detalles')} className={styles.tabColor} />
                </Tabs>
                <TabPanel value={value} index={0} className={styles.textColor}>
                  &nbsp;
                  <br /> &nbsp; &nbsp;
                  <br /> &nbsp;
                </TabPanel>
                <TabPanel value={value} index={1} className={styles.textColor}>
                  &nbsp;
                </TabPanel>
                <TabPanel value={value} index={2} className={styles.textColor}>
                  &nbsp;
                </TabPanel>
                <TabPanel value={value} index={3} className={styles.textColor}>
                  &nbsp;
                </TabPanel>
              </Box>
            </div>
          </>
        )) || (
          <>
            <div className={styles.imageSuperContainer}>
              <div className={styles.imageContainer}>
                <img
                  src={`https://webimages.terramarbrands.com.mx/shopping-cart/cart-products-gray/${productID}.jpg`}
                  alt={name}
                  onError={setAltImg}
                  className={styles.imgContainer}
                />
              </div>
            </div>

            <div className={styles.dataContainer}>
              <Box sx={{ width: '100%' }}>
                <div className={styles.productName}>{name}</div>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  textColor='secondary'
                  indicatorColor='primary'
                  aria-label='secondary tabs example'>
                  <Tab label={t('description')} className={styles.tabColor} />
                  <Tab label={t('ingredients')} className={styles.tabColor} />
                  <Tab label={t('aplication')} className={styles.tabColor} />
                  <Tab label={t('detalles')} className={styles.tabColor} />
                </Tabs>

                <TabPanel value={value} index={0} className={styles.textColor}>
                  {Parser(description || '')}
                </TabPanel>
                <TabPanel value={value} index={1} className={styles.textColor}>
                  {Parser(ingredients || '')}
                </TabPanel>
                <TabPanel value={value} index={2} className={styles.textColor}>
                  {Parser(application || '')}
                </TabPanel>
                <TabPanel value={value} index={3} className={styles.textColor}>
                  <div className={`${styles.containerDetalle} ${styles[screenSize]}`}>
                    {existeRutaVideo && (
                      <div className={styles.videoContainer}>
                        <video
                          src={`https://webimages.terramarbrands.com.mx/webpage/productos/videos/${productID}.mp4`}
                          controls
                          autoPlay
                          muted
                          loop
                          playsInline
                          poster='preview.jpg'
                          width='100%'></video>
                        <a
                          href={`https://webimages.terramarbrands.com.mx/webpage/productos/videos/${productID}.mp4?response-content-disposition=attachment`}
                          target='_blank'
                          rel='noopener noreferrer'
                          className={styles.video}>
                          <div className={styles.linkDescarga}>
                            <div>
                              <img src={download} alt='imagen download' width='28px' />
                            </div>
                            <div>Descargar video</div>
                          </div>
                        </a>
                      </div>
                    )}

                    {existeRuta && (
                      <div className={styles.containerFicha}>
                        <a
                          href={
                            language.includes('es')
                              ? `https://webimages.terramarbrands.com.mx/webpage/productos/fichasTecnicas/${productID}.pdf`
                              : `https://webimages.terramarbrands.com.mx/webpage/productos/fichasTecnicasIngles/${productID}.pdf`
                          }
                          target='_blank'
                          rel='noopener noreferrer'
                          aria-label='Abrir ficha técnica'
                          className={styles.pdf}>
                          <div className={styles.linkDescarga}>
                            <div>
                              <img src={pdfIcon} alt='imagen pdf' width='28px' />
                            </div>
                            <div>Ver ficha técnica</div>
                          </div>
                        </a>
                      </div>
                    )}
                  </div>
                </TabPanel>
              </Box>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Product;
